var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { apiCreateClientRfpAdviser } from '../../../../../actions/ClientRfpActions';
import { wrapDispatch, wrapNotifyError, notify, } from '../../../../../helpers/action';
import { isClient } from '../../../../../helpers/auth';
const useModal = (id, dispatch) => {
    const [isShow, changeModal] = useState(false);
    const auth = useSelector((state) => state.auth);
    const isClientUser = isClient(auth);
    const showModal = useCallback(() => {
        changeModal(true);
    }, [changeModal]);
    const hideModal = useCallback(() => {
        changeModal(false);
    }, [changeModal]);
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiCreateClientRfpAdviser(id, values));
            yield changeModal(false);
            notify(_jsxs("span", { children: ["\u554F\u3044\u5408\u308F\u305B\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002", _jsx("br", {}), "\u3054\u56DE\u7B54\u307E\u3067\u4ECA\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002"] }));
        }));
    }), [id, dispatch, changeModal]);
    return {
        hideModal,
        isDisabled: !isClientUser,
        isShow,
        onSubmit,
        showModal,
    };
};
export const rfpAdviserUseCase = {
    useModal,
};
export default rfpAdviserUseCase;
